import { noop } from "lodash";
import type { RocketchatResponseHandler } from "../RocketchatResponseHandler";
import { handleNewMessageEvent } from "./newMessageEventHandler";
import { handleReadMessageEventHandler } from "./readMessageEventHandler";
import { handleRenewChannelEventHandler } from "./renewChannelEventHandler";

export const chatEventResponseHandler: Record<
  string,
  RocketchatResponseHandler
> = {
  NewMessageEvent: handleNewMessageEvent,
  ReadMessageEvent: handleReadMessageEventHandler,
  RenewChannelEvent: handleRenewChannelEventHandler,
  // TODO: 채팅 버블 구현 시 아래 이벤트 처리 필요
  UpdateBubbleGroupEvent: noop,
  // TODO: 메시지 수정 구현 시 아래 이벤트 처리 필요
  UpdateMessageEvent: noop,
  /**
   * NOTE 1:1 채팅에서는 상대방이 나갔을때 별도의 UI 변경이 없어 이벤트는 전달받지만 처리하지 않습니다.
   */
  LeaveMemberEvent: noop,
  JoinMemberEvent: noop,
};
